import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type AlipayFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const AlipayFilled = forwardRef<SVGSVGElement, AlipayFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-2.524685 -2.283809) scale(1.163062)">
        <path d="M22.3664 15.9321V6.19619C22.3664 4.0967 20.6655 2.39352 18.5674 2.39352H6.40918C4.31175 2.39352 2.61023 4.09602 2.61023 6.19619V18.3663C2.61023 20.4658 4.31107 22.1689 6.40918 22.1689H18.5674C20.4367 22.1689 21.9914 20.8167 22.3076 19.036C21.3006 18.6023 16.933 16.7149 14.659 15.6262C12.9285 17.7248 11.1154 18.9839 8.38255 18.9839C5.64968 18.9839 3.82601 17.3012 4.04587 15.2379C4.19018 13.8837 5.1178 11.6728 9.145 12.0531C11.2676 12.2535 12.2395 12.6498 13.9722 13.2208C14.4175 12.3994 14.7912 11.4948 15.0718 10.5319H7.39742V9.77127H11.1939V8.40222H6.56208V7.56557H11.1939V5.59328C11.1939 5.59328 11.2376 5.28379 11.5765 5.28379H13.4761V7.56557H18.4152V8.40222H13.4761V9.77127H17.5033C17.1341 11.2815 16.5733 12.6669 15.8691 13.8794C17.0406 14.3024 22.3664 15.9321 22.3664 15.9321ZM8.08118 17.6814C5.19373 17.6814 4.73785 15.856 4.88981 15.0954C5.04177 14.3348 5.87762 13.346 7.48281 13.346C9.32866 13.346 10.979 13.8174 12.9626 14.7845C11.5712 16.5995 9.85842 17.6814 8.0812 17.6814H8.08118Z" />
      </g>
    </svg>
  ),
);

AlipayFilled.displayName = 'AlipayFilled';

export default AlipayFilled;
